<template>
    <span style="margin-top: 30px">
        <div class="b-title">Testimonios</div>
        <div class="main-testimonials">
        <div class="margen"><img src="/image/resource/captura29.png" @click="modal = true; videoUrl = 1" class="box-shdow-image" alt="telemedicina" />
            <div style="text-align: center; font-size: 1.5rem; font-weight: 600">Tsushyma Velasquez <img src="/image/flags/venezuela.svg" width="25px"/></div>
            <div style="text-align: center; font-size: 1.2rem; margin-top: -7px">Endocrinólogo</div>
        </div>
        <div class="margen"><img src="/image/resource/captura30.png" @click="modal = true; videoUrl = 2" class="box-shdow-image" alt="telemedicina" />
            <div style="text-align: center; font-size: 1.5rem; font-weight: 600">Dr. Juan Jose Atilano<img src="/image/flags/mexico.svg" width="25px"/></div>
            <div style="text-align: center; font-size: 1.2rem; margin-top: -7px">Médico General</div>
        </div>
        <div class="margen"><img src="/image/resource/captura31.png" @click="modal = true; videoUrl = 3" class="box-shdow-image" alt="telemedicina" />
            <div style="text-align: center; font-size: 1.5rem; font-weight: 600">Maria Hermelinda Varela Baca  <img src="/image/flags/mexico.svg" width="25px"/></div>
            <div style="text-align: center; font-size: 1.2rem; margin-top: -7px">Médico Ginecólogo</div>
        </div>
        <div class="margen"><img src="/image/resource/captura32.png" @click="modal = true; videoUrl = 4" class="box-shdow-image" alt="telemedicina" />
                 <div style="text-align: center; font-size: 1.5rem; font-weight: 600">Dra. Amalia Ferreira <img src="/image/flags/uruguay.svg" width="25px"/></div>
            <div style="text-align: center; font-size: 1.2rem; margin-top: -7px">Odontóloga</div>
        </div>
        <div class="margen"><img src="/image/resource/captura33.png" @click="modal = true; videoUrl = 5" class="box-shdow-image" alt="telemedicina" />
            <div style="text-align: center; font-size: 1.5rem; font-weight: 600">Paola Gutiérrez<img src="/image/flags/colombia.svg" width="25px"/></div>
            <div style="text-align: center; font-size: 1.2rem; margin-top: -7px">Fisiatra</div>
        </div>
    </div>
         <transition name="modal" v-if="modal">
            <div class="modal-mask">
              <div class="modal-wrapper">
                <div class="modal-container">
                  <div class="modal-body">
                      <div v-if="videoUrl === 1"><iframe class="youtube" src="https://www.youtube.com/embed/zf9ucE7gGe8" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>
                      <div v-if="videoUrl === 2"><iframe class="youtube" src="https://www.youtube.com/embed/G1H1EsW2BCk" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>
                      <div v-if="videoUrl === 3"><iframe class="youtube" src="https://www.youtube.com/embed/nRydpy2y14U" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>
                      <div v-if="videoUrl === 4"><iframe class="youtube" src="https://www.youtube.com/embed/IGM6h13wb4o" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>
                      <div v-if="videoUrl === 5"><iframe class="youtube" src="https://www.youtube.com/embed/PI5tb5PujVQ" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>

                      <div><button @click="modal = false" class="btn btn-primary">cerrar</button></div>
                  </div>
                </div>
              </div>
            </div>
          </transition>
    </span>
</template>
<style scoped>
    .b-title{
        font-size: 4rem;
        line-height: 5rem;
        font-weight: 800;
        text-align: center;
        font-family: 'Gayathri', sans-serif;
        color: #4D5CD3;
    }
    .box-shdow-image{
        -webkit-box-shadow: -5px 5px 64px -17px rgba(191,191,191,1);
        -moz-box-shadow: -5px 5px 64px -17px rgba(191,191,191,1);
        box-shadow: -5px 5px 64px -17px rgba(191,191,191,1);
        cursor: pointer;
        width: 220px;
        border-radius: 10px;
        border: 3px solid #4D5CD3;
        transition: box-shadow 0.3s ease-in-out;
    }
    .box-shdow-image:hover{
        -webkit-box-shadow: 0px -1px 18px 0px rgba(0,0,0,0.75);
        -moz-box-shadow: 0px -1px 18px 0px rgba(0,0,0,0.75);
        box-shadow: 0px -1px 18px 0px rgba(0,0,0,0.75);
    }

    .main-testimonials{
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-around;
        width: 100%;
        padding: 30px 0
    }

    .margen{
        margin: 20px 30px;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container {
        width: 600px;
        margin: 0px auto;
        padding: 10px 10px;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
        font-family: Helvetica, Arial, sans-serif;
        display: flex;
        justify-content: center;
    }
    .youtube{
        width: 100%;
        height: 400px;
    }
    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }

    .modal-body {
        margin: 5px 0;
    }

    .modal-default-button {
        float: right;
    }


    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }



    @media (min-width: 481px) and (max-width: 767px) {
        .main-testimonials{
            display: flex;
            flex-direction: column;
        }
        .margen{
            margin: 10px 0;
        }
        .modal-container {
            width: 480px;

        }
    }

    @media (min-width: 120px) and (max-width: 480px) {
        .main-testimonials{
            display: flex;
            flex-direction: column;
        }
        .margen{
            margin: 10px 0;
        }
        .modal-container {
            width: 320px;

        }
    }

</style>
<script>
    import {mapState} from 'vuex'
    import axios from 'axios'
    export default {
        name: 'testimonials',
        components: {

        },
        created(){

        },
        data(){
            return {
                videoUrl: '',
                modal:false,
            }
        },
        computed: {
            ...mapState,


        },
        methods:{

        }

    }
</script>
